<template>
  <div class='detail'>
    <back />
    <div class="content">
      <el-descriptions title="加盟商信息" :column="4">
        <el-descriptions-item label="名称">{{data.companyName	}} </el-descriptions-item>
        <el-descriptions-item label="编号">{{data.companyCode}}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{data.contactMan}}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{data.contactTel}}</el-descriptions-item>
        <el-descriptions-item label="信用代码">{{data.creditCode}}</el-descriptions-item>
        <el-descriptions-item label="加盟时间">{{data.createdTime}}</el-descriptions-item>
        <el-descriptions-item label="状态">{{data.status==1?'启动':'停用'}}</el-descriptions-item>
      </el-descriptions>
    </div>
    <div class="leave_msg">
      <el-descriptions title="" :column="1">
        <el-descriptions-item label="营业执照">
          <el-image style="width: 140px; height: 100px; margin-left: 20px;" :src="data.busiLicenseUrl" fit="cover" @change="changeStatus(scope.row)"></el-image>
        </el-descriptions-item>
      </el-descriptions>
    </div>
    <el-image-viewer v-if="showViewer" :on-close="() => { showViewer = false }" :url-list="imgList"></el-image-viewer>
  </div>
</template>

<script>

export default {
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer'),
  },
  data() {
    return {
      data: {},
      showViewer: false,
      imgList: [],
    }
  },
  created() {
    this.getCompanyInfo()
  },
  methods: {
     // 图片放大
     previewImage(url) {
      this.imgList[0] = url
      this.showViewer = true
    },
    getCompanyInfo() {
      this.$axios.get(this.$api.companyInfo, { params: { id: this.$route.query.id } }).then((res) => {
        if (res.code == 100) {
          this.data = res.result
        }
      }).catch(err => {
        this.$message({
          message: err.desc,
          type: 'error'
        })

      })
    }
  },
}
</script>

<style scoped lang='scss'>
::v-deep .el-descriptions:not(.is-bordered) .el-descriptions-item__cell {
  padding-bottom: 30px !important;
  padding-right:20px ;
}
.detail {
  .content {
    margin-top: 30px;
  }

  .content,
  .leave_msg {
    ::v-deep .el-descriptions__title {
      color: #1a1a1a;
      font-size: 18px;
    }
  }

  .leave_msg {
    ::v-deep .el-descriptions-item__label {
      margin: 0;
    }
    ::v-deep .el-descriptions-item__container {
      align-items: center !important;
    }
  }
}
</style>
